import { EnvironmentApi, EnvironmentInfo } from './EnvironmentApi'
import { RundotGameAPI } from '../rundot-game-api/types'

export class MockEnvironmentApi implements EnvironmentApi {
  private readonly rundotGameApi: RundotGameAPI

  constructor(rundotGameApi: RundotGameAPI) {
    this.rundotGameApi = rundotGameApi
  }

  getEnvironment(): EnvironmentInfo {
    const getBrowser = (): string => {
      if (typeof navigator === 'undefined') return 'unknown'
      const userAgent = navigator.userAgent
      if (/chrome|chromium|crios/i.test(userAgent)) return 'chrome'
      if (/firefox|fxios/i.test(userAgent)) return 'firefox'
      if (/safari/i.test(userAgent)) return 'safari'
      if (/edg/i.test(userAgent)) return 'edge'
      if (/opera|opr/i.test(userAgent)) return 'opera'
      return 'unknown'
    }

    return {
      isDevelopment: true,
      platform: 'web',
      platformVersion: 'mock-1.0',
      browserInfo: {
        browser: getBrowser(),
        userAgent: typeof navigator !== 'undefined' ? navigator.userAgent : 'mock-agent',
        isMobile: typeof navigator !== 'undefined' ? /Mobi|Android/i.test(navigator.userAgent) : false,
        isTablet: typeof navigator !== 'undefined' ? /iPad|Tablet|Pad/i.test(navigator.userAgent) : false,
        language: typeof navigator !== 'undefined' ? (navigator.language || 'en-US') : 'en-US',
      },
      capabilities: {
        ads: true,
        purchases: true,
        subscriptions: true,
        // The mock host has no fullscreen arbitration, so it reports none —
        // matching MockSystemApi, which resolves every fullscreen call inactive.
        fullscreen: 'unavailable',
        pointerLock: false,
        cta: false,
        persistence: 'cloud',
        online: true,
      },
      isSteamDesktop: false,
      isSteamDeck: false,
      executionMode: 'full',
    }
  }
}

